import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DarkModeService {
  private readonly isDarkModeSignal = signal<boolean>(false);

  public readonly logoSrc = computed(() =>
    this.isDarkModeSignal() ? '/assets/logo/okcargo-isologo-white-min.svg' : '/assets/logo/okcargo-isologo-min.svg',
  );

  constructor() {
    this.initializeDarkModeDetection();
  }

  private initializeDarkModeDetection(): void {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    this.isDarkModeSignal.set(mediaQuery.matches);

    mediaQuery.addEventListener('change', (event) => {
      this.isDarkModeSignal.set(event.matches);
    });
  }

  get isDarkMode(): boolean {
    return this.isDarkModeSignal();
  }
}
